// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'row';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.313.565H1.688C1.066.565.563 1.068.563 1.69v1.125c0 .621.503 1.125 1.125 1.125h14.624c.622 0 1.125-.504 1.125-1.125V1.69c0-.622-.503-1.125-1.125-1.125zm0 6.75H1.688c-.622 0-1.125.503-1.125 1.125v1.125c0 .621.503 1.125 1.125 1.125h14.624c.622 0 1.125-.504 1.125-1.125V8.44c0-.622-.503-1.125-1.125-1.125zm0 6.75H1.688c-.622 0-1.125.503-1.125 1.125v1.125c0 .621.503 1.125 1.125 1.125h14.624c.622 0 1.125-.504 1.125-1.125V15.19c0-.622-.503-1.125-1.125-1.125z'
  />
);

export const viewBox = '0 0 18 18';
